export default class QuantityLessOrEqualZeroError extends Error {
}
